import { IFarmPlayerState, IFarmState } from './IFarmPlayerState';

export const initialFarmPlayerState: IFarmPlayerState = {
    slots: {
        house_0: { itemId: "house_usa" },
    },
    unlockedAreas: ['area_0']
};

export const initialFarmState: IFarmState = {
    constructionModeEnabled: false,
    previewSlots : {}
};
